import { Box } from "@outschool/backpack";
import { SectionTeaser_SectionFragment } from "@outschool/gql-frontend-generated";
import { gql } from "@outschool/ui-apollo";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

import useSectionString from "../../../shared/hooks/useSectionString";
import * as Routes from "../../../shared/Routes";
import { useTimeZone } from "../../providers/TimeZoneProvider";
import Link from "../Link";

/*
 * A block which briefly describes a Section and links to the sectionLearnerPath
 */
export default function SectionTeaser({
  section,
  learner
}: {
  section: SectionTeaser_SectionFragment;
  learner: { uid: string };
}) {
  const { timeZone: userTimeZone } = useTimeZone();
  const { fullDurationString } = useSectionString();
  return section && learner ? (
    <Link to={Routes.sectionLearnerPath(section, learner)}>
      <Box>
        <Box>
          {section.activity.title} &mdash;{" "}
          {fullDurationString({
            activity: section.activity,
            section,
            nextOngoingMeeting: section.nextOngoingMeeting,
            userTimeZone
          })}
        </Box>
      </Box>
    </Link>
  ) : null;
}

SectionTeaser.fragments = {
  section: gql`
    fragment SectionTeaser_section on Section {
      uid
      start_time
      end_time
      nextOngoingMeeting {
        uid
        start_time
        end_time
      }
      activity {
        uid
        title
        isClub
        weekly_meetings
        duration_weeks
        is_ongoing_weekly
        hasTeacherSchedule
        published_at
      }
    }
  `
};
